<script>
import carousel from 'components/mixins/carousel';
import SvgLoader from 'components/svg_loader.vue';

import Testimonial from './testimonial.vue';

export default {
  components: {
    SvgLoader,
    Testimonial
  },

  mixins: [
    carousel
  ],

  data() {
    return {
      arrowSvg: 'payment_page/testimonial_arrow',
      cards: this.$store.state.testimonials
    };
  },

  computed: {
    testimonials() {
      return this.cards;
    },

    hasMoreThanOneTestimonials() {
      return this.testimonials.length > 1;
    }
  },

  mounted() {
    this.addMediaQueryListener();
  },

  methods: {
    addMediaQueryListener() {
      window.matchMedia('(min-width: 768px)').onchange = (e) => {
        if (e.matches) {
          this.transitioning = false;
          this.setStep();
        }
      };
    }
  }
};
</script>

<template>
  <div
    v-if="testimonials.length"
    class="c-testimonials"
  >
    <span
      v-if="hasMoreThanOneTestimonials"
      class="c-testimonials__arrow"
      @click="onSlide('prev')"
    >
      <svg-loader :path="arrowSvg" />
    </span>

    <div class="c-testimonials__carousel">
      <div
        ref="inner"
        class="c-testimonials__carousel--inner"
        :style="innerStyles"
      >
        <testimonial
          v-for="testimonial in testimonials"
          :key="testimonial.name"
          v-bind="testimonial"
        />
      </div>
    </div>

    <span
      v-if="hasMoreThanOneTestimonials"
      class="c-testimonials__arrow c-testimonials__arrow--right"
      @click="onSlide('next')"
    >
      <svg-loader :path="arrowSvg" />
    </span>
  </div>
</template>
